import { render, staticRenderFns } from "./SystemStatistics.vue?vue&type=template&id=e8792e30&scoped=true"
import script from "./SystemStatistics.vue?vue&type=script&lang=js"
export * from "./SystemStatistics.vue?vue&type=script&lang=js"
import style0 from "./SystemStatistics.vue?vue&type=style&index=0&id=e8792e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8792e30",
  null
  
)

export default component.exports